import { LocalStorageCache } from '@/shared/utils/local-storage-cache';
import type { UserOrganizationWithRole } from '../types/organization.type';

/**
 * LocalStorage cache for user's organization (legacy, kept for cache clearing)
 */
export const organizationStorage =
	new LocalStorageCache<UserOrganizationWithRole>({
		storageKey: 'user_organization',
	});

/**
 * LocalStorage cache for all of the user's organizations
 */
export const organizationsStorage = new LocalStorageCache<
	UserOrganizationWithRole[]
>({
	storageKey: 'user_organizations',
});

/**
 * LocalStorage cache for the ID of the currently active organization
 */
export const currentOrgIdStorage = new LocalStorageCache<string>({
	storageKey: 'current_organization_id',
});

/**
 * The organization the user is currently working in, for request bodies.
 *
 * Client-only: reads localStorage, returns undefined during SSR. Returns
 * `undefined` rather than `null` so it can be spread straight into a request
 * body and simply be absent when unknown.
 *
 * WHY CALLERS MUST SEND THIS. Omitting `organizationId` does not mean "no
 * organization" to the backend — the billing interceptor falls back to
 * `getFirstOrganizationIdForUser`, an unordered query taking the first row. For
 * a user in one organization that is harmless. For a user in several it
 * authorizes the hold against an arbitrary account, which the user experiences
 * as INSUFFICIENT_BALANCE while looking at a balance that is plainly not empty
 * (TSO-810). Any request that BILLS must carry this.
 */
export function readCurrentOrganizationId(): string | undefined {
	if (typeof window === 'undefined') return undefined;
	try {
		return currentOrgIdStorage.get() ?? undefined;
	} catch {
		return undefined;
	}
}
